export default __webpack_public_path__ + "static/media/gov.c1c79ea0.png";